import React from 'react';
import { Formik, useField, Form } from 'formik';
import './Forms.css';
import * as Yup from 'yup';
import Button from '@mui/material/Button';




const CustomTextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props)
    return (
        <>
            <label className="labelForms" htmlFor={props.id || props.name}>{label}</label>
            <input className="text-input-forms"{...field}{...props} />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </>
    )
}
const CustomSelect = ({ label, ...props }) => {
    const [field, meta] = useField(props)
    return (
        <>
            <label htmlFor={props.id || props.name}>{label}</label>
            <select {...field}{...props} />
            {meta.touched && meta.error ? (
                <div className="error-select">{meta.error}</div>
            ) : null}
        </>
    )
}
export default function FormsRenew() {
    return (
        <Formik
            initialValues={{
                name: '',
                email: '',
                license: '',
                date: ''
            }}
            validationSchema={Yup.object({
                name: Yup.string()
                    .required('Nome não pode ficar em branco!'),
                email: Yup.string()
                    .email('Formato inválido!')
                    .required('Email não pode ficar em branco!'),
                license: Yup.string()
                    .required('Necessário escolher a licença que deseja renovar!'),
                date: Yup.string()
                    .oneOf(['1mes', '3meses', '6meses', '1ano', '2anos'])
                    .required('Necessário escolher uma data!'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                setTimeout(() => {
                    alert(JSON.stringify(values, null, 2));
                    resetForm();
                    setSubmitting(false);
                }, 3000)
            }}
        >
            {props => (
                <div className="formsContainer">
                    <Form>
                        <div className="tittleForms">
                            <h3>Renovar Licença</h3>
                        </div>
                        <h6>Empresa:</h6>
                        <CustomTextInput name="name" type="text" placeholder="Digite o nome da empresa" />
                        {/* <h6>E-mail:</h6>
                        <CustomTextInput name="email" type="email" placeholder="Digite seu email" /> */}
                        <h6>Licença: </h6>
                        <CustomTextInput name="license" type="text" placeholder="Digite o numero/tolken" />
                        <h6>Tempo que deseja renovar:</h6>
                        <CustomSelect name="date">
                            <option value="">Selecione a duração</option>
                            <option value="1mes">1 mês</option>
                            <option value="3meses">3 meses</option>
                            <option value="6meses">6 meses</option>
                            <option value="1ano">1 ano</option>
                            <option value="2anos">2 anos</option>
                        </CustomSelect>
                        <div className="buttonFormsContainer">
                            <Button variant="contained">Solicitar licença</Button>
                        </div>
                    </Form>
                </div>
            )}
        </Formik>
    );
}